import { render } from "./SubscriptionsComponent.vue?vue&type=template&id=27aac740&scoped=true"
import script from "./SubscriptionsComponent.vue?vue&type=script&lang=js"
export * from "./SubscriptionsComponent.vue?vue&type=script&lang=js"

import "./SubscriptionsComponent.vue?vue&type=style&index=0&id=27aac740&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27aac740"]])

export default __exports__